import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, registrationTypeId, registrationType) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/RegistrationTypes/${registrationTypeId}`, method: 'PUT', body: registrationType, token: token })
}
